import * as CFG from '@siloreal:app:config';

const version = CFG.version
  .split('.')
  .map((v) => v.padStart(5, '0'))
  .join('');
export const GLOBAL_STORE_VERSION = Number(version);
